import {
  inputDisabled,
  inputError,
  inputFocus,
  inputOutlined,
  textareaBase,
} from '@/core/constants/class-names'
import { cn } from '@/core/lib/utils/cn'
import { createInput } from './input-factory'

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string | boolean
  errorMessage?: string
}

const BaseTextArea: React.FC<TextAreaProps> = ({
  className = '',
  error,
  errorMessage,
  ...rest
}) => {
  const hasError = Boolean(error)

  return (
    <div className='flex w-full flex-col gap-1'>
      <textarea
        {...rest}
        className={cn(
          'text-navy',
          textareaBase,
          inputOutlined,
          inputDisabled,
          inputFocus,
          hasError && inputError,
          className,
        )}
      />
      {hasError && errorMessage && (
        <p className='text-red text-sm'>{errorMessage}</p>
      )}
    </div>
  )
}

export const TextArea = createInput(BaseTextArea, ['label'])
export const FormTextArea = createInput(BaseTextArea, ['form', 'label'])
